import menuApp from '@/images/Header/menu-app.svg';
import menuCloud from '@/images/Header/menu-cloud.svg';
import menuConcierge from '@/images/Header/menu-concierge.svg';

import { Links, ScrollLinks } from '@/utils/constants';

export const MENU_LIST_ITEMS = [
  { name: 'Products', canOpen: true },
  { name: 'Templates', canOpen: false, href: Links.TEMPLATES },
  { name: 'Blog', canOpen: false, href: Links.BLOG },
  { name: 'Pricing', canOpen: false, href: Links.PRICING },
];

export const menuOpenLeft = [
  {
    href: ScrollLinks.WHY_CODEPLATFROM,
    text: 'Why CodePlatform?',
  },
  {
    href: ScrollLinks.HOW_CODEPLATFORM_WORKS,
    text: 'How CodePlatform works',
  },
  {
    href: ScrollLinks.WHO_IS_CODEPLATFORM_FOR,
    text: 'Who is CodePlatform for?',
  },
];

export const menuOpenRight = [
  {
    href: Links.HOME,
    color: 'transparent',
    image: menuApp,
    text: 'App Starters',
  },
  {
    href: Links.HOME,
    color: 'transparent',
    image: menuCloud,
    text: 'Cloud Platform',
  },
  {
    href: Links.HOME,
    color: 'transparent',
    image: menuConcierge,
    text: 'Concierge Services',
  },
];
